import moment from "moment";
import * as yup from "yup";
import {
  PRINCIPAL_INVESTIGATOR,
  SPONSOR,
  TITLE,
  DEPARTMENT,
  DOCUMENTS,
  LABEL,
  MICR,
  PROTOCOL_NUMBER,
  REQUIRED,
  _URL,
  PROTOCOL_NUMBER_OTHERS,
} from "../../../../constants/forms";
import { EMAILS } from "../../../../constants/forms";
import { STUDY_PHASE } from "../../../../constants/forms";
import { TYPE_OF_STUDY } from "../../../../constants/forms";
import { IS_TERMS_ACCEPTED } from "../../../../constants/forms";
import { IS_FUNDED } from "../../../../constants/forms";
import { FUND_TYPE } from "../../../../constants/forms";
import { DATE_OF_IRB_SUBMISSION } from "../../../../constants/forms";
import { TYPE_OF_STUDY_OTHER } from "../../../../constants/forms";
import { IRB_PRESENTATION } from "../../../../constants/forms";

export const createIRBAdditionalSubInitData = {
  [PROTOCOL_NUMBER]: "",
  [PROTOCOL_NUMBER_OTHERS]: "",
  [MICR]: "",
  [TITLE]: "",
  [SPONSOR]: "",
  [PRINCIPAL_INVESTIGATOR]: "",
  [DEPARTMENT]: "",
  [EMAILS]: [],
  [STUDY_PHASE]: "",
  [TYPE_OF_STUDY]: "",
  [IS_TERMS_ACCEPTED]: false,
  [IS_FUNDED]: false,
  [FUND_TYPE]: "",
  [DATE_OF_IRB_SUBMISSION]: moment().format("yyyy-MM-DD"),
  [TYPE_OF_STUDY_OTHER]: "",
  [DOCUMENTS]: [],
  [IRB_PRESENTATION]: "",
};

const studyDetailsStepValidation = yup.object().shape({
  [PROTOCOL_NUMBER]: yup.string().nullable().required("Invalid protocol"),
  [TITLE]: yup.string().required("Study title is required"),
  [SPONSOR]: yup.string().required("Sponsor name is required"),
  principalInvestigator: yup
    .string()
    .required("Principal investigator name is required"),

  [DEPARTMENT]: yup.string().required("Department is required"),
  [EMAILS]: yup
    .array()
    .of(yup.string())
    .min(1, "Please add training")
    .required("Emails are required"),
  [STUDY_PHASE]: yup.string().required("Study phase is required"),
  [TYPE_OF_STUDY]: yup.string().required("Types of study is required"),
  [FUND_TYPE]: yup.string().when("isFunded", {
    is: true,
    then: yup.string().required("isFunded type is required"),
  }),
  [IS_TERMS_ACCEPTED]: yup
    .boolean()
    .isTrue("Please accept the terms first.")
    .required("Please accept the terms first."),
});

const irbAddSubmissionStepValidation = yup.object().shape({
  [DATE_OF_IRB_SUBMISSION]: yup
    .date()
    .required("Date of MIRB submission is required "),
  [DOCUMENTS]: yup
    .array()
    .of(
      yup.object().shape({
        [LABEL]: yup.string().required("Label is required"),
        [REQUIRED]: yup.boolean().required(),
        [_URL]: yup.string().when(REQUIRED, {
          is: true,
          then: yup.string().test(_URL, function (value) {
            const label = this.parent[LABEL] || '';
            return (
              Boolean(value) ||
              this.createError({ message: `Please add ${label} document` })
            );
          }),
          otherwise: yup.string(),
        }),
      })
    )
    .required("At least one document is required")
    .min(1),
});
export const IRBAdditionalSubmissionValidationSchema = [
  studyDetailsStepValidation,
  irbAddSubmissionStepValidation,
];
